var _style, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWalletWithDot = function SvgWalletWithDot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgWalletWithDot",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgWalletWithDot{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    className: "svgWalletWithDot svgBase svgHover svgSelect",
    d: "M13.7,3h-1.9V2.3c0-0.9-0.8-1.7-1.7-1.7c0,0,0,0,0,0H2.3c-0.9,0-1.7,0.8-1.7,1.7c0,0,0,0,0,0 v11.4c0,0.9,0.8,1.7,1.7,1.7c0,0,0,0,0,0h11.4c0.9,0,1.7-0.8,1.7-1.7c0,0,0,0,0,0V4.7C15.4,3.8,14.6,3,13.7,3z M1.6,3.9 C1.8,4,2.1,4,2.3,4h11.4c0.4,0,0.7,0.3,0.7,0.7v8.9c0,0.4-0.3,0.7-0.7,0.7H2.3c-0.4,0-0.7-0.3-0.7-0.7L1.6,3.9L1.6,3.9z M10.7,3H2.4 v0H2.3C1.9,3,1.6,2.7,1.6,2.3c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0H10c0.4,0,0.7,0.3,0.7,0.7L10.7,3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    className: "svgWalletWithDot svgBase svgHover svgSelect",
    d: "M11.4,12.5c0.4,0,0.8-0.4,0.8-0.8c0-0.4-0.3-0.8-0.8-0.8s-0.8,0.3-0.8,0.8c0,0,0,0,0,0.1 C10.6,12.1,11,12.5,11.4,12.5C11.4,12.5,11.4,12.5,11.4,12.5z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWalletWithDot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet_with_dot.022c1328.svg";
export { ForwardRef as ReactComponent };